/* eslint-disable react/jsx-filename-extension */
/* eslint-disable no-unused-vars */
import React from 'react';
import ReactDOM from 'react-dom';
import './assets/index.css';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import ScriptTag from 'react-script-tag';
import store from './redux/rematch';
import App from './App';
import intercomJs from './assets/js/intercom';
import customerIODev from './assets/js/_cio_dev';

const ProductionScriptTags = () => {
  return null;
};

ReactDOM.render(
  <>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </>,
  document.getElementById('root'),
);
